export default (): boolean => {
	return document.body.getAttribute('dir') === 'rtl'
}